export enum RebookingDecision {
    HOLD = 'Hold room',
    RELEASE = 'Release room',
}
